function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("title", null, "Ic_check");
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Ic_check",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#0072EA",
  fill: "#0072EA",
  x: 0,
  y: 0,
  width: 12,
  height: 12,
  rx: 1
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  points: "3 6.5 5 8.5 9 3.5"
}))));
const SvgIcCheck = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Ic_check.0ca638cf.svg";
export { ForwardRef as ReactComponent };